let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fk0rq")).then(() => parcelRequire('63lkD'));